import styled from 'styled-components';
import {
  Box,
  cssColorValue,
  semanticColors,
  spacer12,
  spacer16,
  spacer24,
  spacer8,
} from '@spotify-internal/encore-web/core';

export const StyledBox = styled(Box)`
  z-index: auto;
  cursor: initial;
`;

export const StyledTrackRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${spacer24};
  justify-content: space-between;
`;

export const StyledTrackRowInner = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledTrackNumber = styled.div`
  margin-right: ${spacer16};
  margin-left: -${spacer8};
`;

export const StyledImageContainer = styled.div`
  margin-right: ${spacer12};
  display: flex;
`;

export const StyledTrackNameDetails = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 88px;
`;

export const PillsContainer = styled.div`
  margin-bottom: ${spacer16};
  display: flex;
`;

export const StyledNameAndExplicitTagContainer = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const CtaContainer = styled.div`
  display: flex;
  background-color: ${cssColorValue(semanticColors.backgroundHighlight)};
  height: 316px;
  justify-content: center;
`;
